import React, { useState } from 'react';
import { Button, Grid, List, ListItem, Collapse, Typography, Switch, FormControlLabel } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { formatNumberAsEuro } from "./helpers";



const PricingDetails = ({ product, chosenEntity, isBusiness }) => {
    const [openElectricityDetails, setOpenElectricityDetails] = useState(false);
    const [openGasDetails, setOpenGasDetails] = useState(false);
    const [isMonthly, setIsMonthly] = useState(false); // Nieuwe state voor de switch

    const convertToFloat = (value) => {

        //if value is a float or int return it
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value ==='string') {
            // strip whitespace
            console.log("in: ", value);
            value = value.toString().replace(/\s/g, '');

            let isNegative = value.includes("-");

            // Remove periods and replace the last comma with a period for correct parsing.
            let stringValue = value.toString().replace(/\./g, '').replace(/,(\d{2})$/, '.$1');
            value = parseFloat(stringValue);


            // convert to number
            value = parseFloat(value);

            // if value was negative, but now is positive, convert to negative
            if (isNegative && value > 0) {
                value = value * -1;
            }

            console.log("out: ", value);

            return value;
        }
        console.error("value is not a number or string");
        return 0;

    }


    // create a convert to negative function
    const convertToNegative = (value) => {
        // if value is a float or int return it
        if (typeof value === 'number') {
            return value * -1;
        }
        return value;
    }




    // Pas de toggle functie aan om de switch state te updaten
    const togglePricePeriod = () => {
        setIsMonthly(prev => !prev);
    };

    // Functie voor het omzetten van jaarlijkse naar maandelijkse prijzen en vice versa
    const convertPrice = (price) => {
        return isMonthly ? price / 12 : price;
    };


    const toggleElectricityDetails = () => {
        setOpenElectricityDetails(prev => !prev);
    };

    const toggleGasDetails = () => {
        setOpenGasDetails(prev => !prev);
    };

    const appendIncVatToKeys  = (obj) => {
        Object.keys(obj).forEach(key => {
            obj[key + "_inc_vat"] = obj[key];
            delete obj[key];
        });
    }

    const getRequiredPropertiesToShow = (chosenEntity) => {
        const isBusiness = chosenEntity === "Zakelijk";

        // Common properties for both electricity and gas
        const commonProperties = {
            "fixed_delivery_cost": "Vaste leveringskosten",
            "tariff_grid_operator_year": "Netbeheerkosten",
            "government_tax_per_year": "Belastingen",
            "purchase_surcharge_cost": "Inkoopvergoeding",

        };

        // Extra properties for electricity
        const electricityExtraProperties = {
            "tax_reduction": "Vermindering energiebelasting",
            "total": "Totaal stroom",
        };

        // Extra properties for gas
        const gasExtraProperties = {
            "total": "Totaal gas",
        }; // Leeg voor nu, kan later worden uitgebreid

        // Extra properties for tariff
        const tariffProperties = {
            "dynamic_average_tariff": "Gemiddeld dynamisch tarief",
            "purchase_surcharge_tariff": "Inkoopvergoeding",
        };

        // Merge all properties together
        const electricityProperties = {...commonProperties, ...electricityExtraProperties};
        const gasProperties = {...commonProperties, ...gasExtraProperties};

        // Add inc vat properties if not business
        if (!isBusiness) {
            appendIncVatToKeys(electricityProperties);
            appendIncVatToKeys(gasProperties);
            appendIncVatToKeys(tariffProperties);
        }

        return {
            "electricity": { base: electricityProperties, tariff: tariffProperties },
            "gas": { base: gasProperties, tariff: tariffProperties }
        };
    }


    const propertiesToShow = getRequiredPropertiesToShow(chosenEntity);

    // Functie voor het berekenen van elektriciteitsdetails
    const getElectricityDetails = (electricitySpecs, isBusiness, baseProperties) => {
        let details = [];

        // Bereken de totale kosten voor verbruik en teruglevering
        const fullUsageHigh = electricitySpecs.full_usage_high;
        const fullUsageLow = electricitySpecs.full_usage_low;
        const fullReturnHigh = electricitySpecs.full_return_high;
        const fullReturnLow = electricitySpecs.full_return_low;

        const averageTariff = isBusiness ? electricitySpecs.tariff.dynamic_average_tariff : electricitySpecs.tariff.dynamic_average_tariff_inc_vat;

        const VerbruikHoogTotal = (fullUsageHigh * averageTariff);
        const VerbruikLaagTotal = (fullUsageLow * averageTariff);
        const TerugleveringHoogTotal = (fullReturnHigh * averageTariff);
        const TerugleveringLaagTotal = (fullReturnLow * averageTariff);

        // Voeg aangepaste tariefdetails toe aan de lijst
        details.push({
            label: "Verbruik Hoog",
            subLabel: `${fullUsageHigh} kWh x ${formatNumberAsEuro(convertToFloat(averageTariff))}`,
            value: convertToFloat(VerbruikHoogTotal, isMonthly)
        });
        details.push({
            label: "Verbruik Laag",
            subLabel: `${fullUsageLow} kWh x ${formatNumberAsEuro(convertToFloat(averageTariff))}`,
            value: convertToFloat(VerbruikLaagTotal, isMonthly)
        });
        // We no longer ask the user if they return energy. Keeping this commented in case this decision is reverted.
        // details.push({
        //     label: "Teruglevering Hoog",
        //     subLabel: `${fullReturnHigh} kWh x ${formatNumberAsEuro(convertToFloat(averageTariff))}`,
        //     value: convertToNegative(convertToFloat(TerugleveringHoogTotal, isMonthly))
        // });
        // details.push({
        //     label: "Teruglevering Laag",
        //     subLabel: `${fullReturnLow} kWh x ${formatNumberAsEuro(convertToFloat(averageTariff))}`,
        //     value: convertToNegative(convertToFloat(TerugleveringLaagTotal, isMonthly))
        // });

        // Voeg de basis tariefdetails toe
        Object.entries(baseProperties).forEach(([key, label]) => {
            if(key === "tax_reduction") {
                details.push({
                    label,
                    value: convertToNegative(convertToFloat(electricitySpecs[key], isMonthly)),
                });
            } else {
                details.push({
                    label,
                    value: convertToFloat(electricitySpecs[key], isMonthly),
                });
            }
        });

        return details;
    };

    // Elektriciteitstarieven en -details
    const electricityDetails = product.cost_specifications && product.cost_specifications.electricity
        ? getElectricityDetails(product.cost_specifications.electricity, isBusiness, propertiesToShow.electricity.base)
        : [];


// Functie voor het berekenen van gasdetails
    const getGasDetails = (gasSpecs, isBusiness, baseProperties) => {
        let details = [];

        // Bereken de totale kosten voor gasgebruik
        const fullUsageGas = gasSpecs.usage; // Vervang dit door de werkelijke eigenschapsnaam indien nodig
        const averageGasTariff = isBusiness ? gasSpecs.tariff.dynamic_average_tariff : gasSpecs.tariff.dynamic_average_tariff_inc_vat;

        const gasUsageTotal = (fullUsageGas * averageGasTariff);

        // Voeg het aangepaste gasverbruik detail toe
        details.push({
            label: "Gasverbruik",
            subLabel: `${fullUsageGas} M³ x ${formatNumberAsEuro(convertToFloat(averageGasTariff))}`,
            value: convertToFloat(gasUsageTotal)
        });

        // Voeg basis tariefdetails toe
        Object.entries(baseProperties).forEach(([key, label]) => {
            details.push({
                label,
                value: convertToFloat(gasSpecs[key]),
            });
        });

        return details;
    };


    // Gastarieven en -details
    const gasDetails = product.cost_specifications && product.cost_specifications.gas
        ? getGasDetails(product.cost_specifications.gas, isBusiness, propertiesToShow.gas.base)
        : [];



    const totalPrice = product.cost_specifications && (
        isBusiness
            ? convertToFloat(product.cost_specifications.total.total)
            : convertToFloat(product.cost_specifications.total.total_inc_vat)
    ) || 0;

    const totalVAT = product.cost_specifications && (
        convertToFloat(product.cost_specifications.total.total_vat)) || 0;




    return (
        <div>
            <div className="pricedetail-switch">
            <FormControlLabel
                control={<Switch checked={isMonthly} onChange={togglePricePeriod} />}
                label={isMonthly ? "Maandelijkse prijzen" : "Jaarlijkse prijzen"}
            />
            </div>

            {electricityDetails.length > 0 && (
                <div className="pricedetail-elec-wrapper">

                    {electricityDetails.map((detail, index) => {
                        if (detail.label === "Totaal stroom") {
                            return (
                                <Grid container spacing={2} key={index}>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle1">{detail.label}</Typography>
                                    </Grid>
                                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                                        <Typography variant="body2">{formatNumberAsEuro(convertPrice(detail.value))}</Typography>
                                    </Grid>
                                </Grid>
                            );
                        }
                        return null;
                    })}


                    <Button onClick={toggleElectricityDetails} className="pricedetails-accordion pricedetails-accordion-elec" endIcon={openElectricityDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                        Stroomtarieven {openElectricityDetails ? 'verbergen' : 'bekijken'}
                    </Button>
                    <Collapse in={openElectricityDetails}>
                        <List>
                            {electricityDetails.map((detail, index) => (
                                <ListItem key={`electricity-${index}`}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">{detail.label}</Typography>
                                            {detail.subLabel && <Typography variant="body2" style={{ display: 'block' }}>{detail.subLabel}</Typography>}
                                        </Grid>
                                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                                            <Typography variant="body2">{ formatNumberAsEuro(convertPrice(detail.value))}</Typography>
                                        </Grid>
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </div>
            )}

            {gasDetails.length > 0 && (
                <div className="pricedetail-gas-wrapper">
                    {gasDetails.map((detail, index) => {
                        if (detail.label === "Totaal gas") {
                            return (
                                <Grid container spacing={2} key={index}>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle1">{detail.label}</Typography>
                                        {detail.subLabel && <Typography variant="body2" style={{ display: 'block' }}>{detail.subLabel}</Typography>}
                                    </Grid>
                                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                                        <Typography variant="body2">{formatNumberAsEuro(convertPrice(detail.value))}</Typography>
                                    </Grid>
                                </Grid>
                            );
                        }
                        return null;
                    })}


                    <Button onClick={toggleGasDetails} className="pricedetails-accordion pricedetails-accordion-gas" endIcon={openGasDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                        Gastarieven {openGasDetails ? 'verbergen' : 'bekijken'}
                    </Button>
                    <Collapse in={openGasDetails}>
                        <List>
                            {gasDetails.map((detail, index) => (
                                <ListItem key={`gas-${index}`}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">{detail.label}</Typography>
                                            {detail.subLabel && <Typography variant="body2" style={{ display: 'block' }}>{detail.subLabel}</Typography>}
                                        </Grid>
                                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                                            <Typography variant="body2">{formatNumberAsEuro(convertPrice(detail.value))}</Typography>
                                        </Grid>
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </div>
            )}

            <div className="pricedetail-totals-wrapper">

            {totalPrice && (
                <div className="pricedetail-totalprice-wrapper">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        {isBusiness? (
                            <Typography variant="subtitle1" className="pricedetail-total-label">Totaal (excl BTW)</Typography>
                            ) : (
                                <Typography variant="subtitle1" className="pricedetail-total-label">Totaal (incl BTW)</Typography>
                            )
                        }
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <Typography variant="body2" className="pricedetail-total-price" >{formatNumberAsEuro(convertPrice(totalPrice))}</Typography>
                    </Grid>
                </Grid>
                </div>
                )}
            {totalVAT && (
                <div className="pricedetail-totalvat-wrapper">
                <Grid container spacing={2}>
            <Grid item xs={6}>
                {isBusiness? (
                    <Typography variant="subtitle1" className="pricedetail-btw-label">BTW</Typography>
                ) : (
                    <Typography variant="subtitle1" className="pricedetail-btw-label">BTW</Typography>
                )
                }
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
                <Typography variant="body2" className="pricedetail-btw-price">{formatNumberAsEuro(convertPrice(totalVAT))}</Typography>
            </Grid>
        </Grid>
                </div>
            )}
            </div>

        </div>
    );
};

export default PricingDetails;
